<template>
  <div class="metrics-dashboard">
    <div class="container mt-5 mb-5">
      <div class="row">
        <div class="col-md-4 mt-4 mb-4" v-for="metric in metrics" :key="metric.id">
          <router-link
            :to="{ name: metric.router_link }"
            class="card-adela-anchor"
            v-if="$can('read', metric.subject)"
          >
            <div class="card-adela-item card-adela-diseno">
              <div class="card-adela-badge" style="background-color:#FA7800">
                <font-awesome-icon :icon="['fal', metric.icon]" />
              </div>
              <div class="card-adela-category">
                <h2>{{ metric.title }}</h2>
                <span>{{ metric.description }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">

export default {
  data () {
    return {
      metrics: [
        {
          id: 1,
          icon: 'chart-bar',
          title: 'Utilidad',
          description: 'Muestra las metas de utilidades por mes.',
          router_link: 'metrics-utility',
          subject: 'GeneralReport'
        }
      ]
    }
  }
}
</script>
